<template>
  <div>
    <el-form ref="form" :rules="rules" :model="form">
      <el-form-item
        label="广告活动"
        prop="campaignId">
        <gj-select
            v-if="isMeaningless(campaign)"
            v-model="form.campaignId"
            width="200px"
            placeholder="请选择"
            :clearable="false"
            :options="proxyCampaignOption"
            :loading="campaignLoading"
            @input="campaignChange($event)">
        </gj-select>
        <template v-else>
          {{campaign.campaignName | defaultShow}}
        </template>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { isMeaningless, isMeaningful } from "@/utils/common";
import { adStore } from "modules/ad/common/store";
import { spinnerSbCampaign } from '@/api/ad'
export default {
  name: "app-sb-base-info",
  data() {
    return {
      adStore,
      isMeaningless, isMeaningful,
      campaignLoading: false,
      proxyCampaignOption: [], // 广告活动
      rules: {
        campaignId: [
          { required: this.required.activity, message: '请选择广告活动', trigger: ['change'] }
        ]
      }
    }
  },
  props: {
    form: {
      required: true
    },
    required: {
      required: false,
      default: () => ({
        activity: true, // 广告活动必填
      })
    },
    targetingType: {
      required: true,
      default: 0 // 0:关键词投放；1：商品投放
    }
  },
  methods: {
    // 获取广告活动下拉列表
    async spinnerSbCampaign() {
      this.campaignLoading = true
      let params = {
        marketId: this.marketId,
        targetingType: this.targetingType
      }
      let { data } = await spinnerSbCampaign(params) || []
      data.forEach(item => {
        item.id = item.campaignId
        item.text = item.campaignName
      });
      this.proxyCampaignOption = data
      this.campaignLoading = false
    },
    // 获取建议关键词列表
    async campaignChange(campaignId) {
      let item = this.proxyCampaignOption.find(e => e.campaignId == campaignId)
      this.form.groupId = item.groupId
      this.$emit("campaignChange", campaignId, this.proxyCampaignOption)
    },
    formValidate() {
      let formValid = false;
      this.$refs.form.validate((valid) => {
        formValid = valid;
      });
      return formValid;
    }
  },
  computed: {
    // 广告活动
    campaign() {
      return this.adStore.SB.campaign
    },
    // 站点id
    marketId() {
      return this.adStore.SB.marketId
    },
  },
  created() {
    if (this.isMeaningless(this.campaign)) {
      this.spinnerSbCampaign()
    }else {
      this.form.campaignId = this.adStore.SB.campaign.campaignId
      this.form.groupId = this.adStore.SB.campaign.groupId
    }
  }
}
</script>

<style scoped lang="scss">
/deep/.el-form-item__label {
  padding-left: 6px;
  text-align: left;
  font-size: 12px;
  color: #333;
  position: relative;
  font-weight: 500;
  &::before {
    position: absolute;
    top: 0;
    left: -5px;
  }
}
</style>